import React from 'react'
import { Query } from 'react-apollo'
import { Pie } from 'react-chartjs-2'
import _orderBy from 'lodash/orderBy'

import { azure, red, orange, blue, green, pieChartDataset } from 'variables/chartSettings'

import statsAgentePieCharts from 'graphql/queries/statsAgentePieCharts'

// material-ui components
import withStyles from 'material-ui/styles/withStyles'

import GridContainer from 'components/Grid/GridContainer.jsx'
import ItemGrid from 'components/Grid/ItemGrid.jsx'

import 'chart.piecelabel.js'
import chartsStyle from 'assets/jss/material-dashboard-pro-react/views/chartsStyle.jsx'


class Performance extends React.Component {

  renderNomeVoto = (voto, valore, tipoVoto) => {
    const sum = function(a, b) { return a + b }
    
    let nomeVoto = ''
    
    switch (voto) {
      case "0":
        nomeVoto = 'Non contattato'
        break
      case "1":
        nomeVoto = 'Molto scadente'
        break
      case "2":
        nomeVoto = 'Scadente'
        break
      case "3":
        nomeVoto = 'Buono'
        break
      case "4":
        nomeVoto = 'Molto buono'
        break
      case "5":
        nomeVoto = 'Eccellente'    
        break
      default:
        nomeVoto = ''
        break
    }
    
    return Math.round(valore / tipoVoto.reduce(sum, 0) * 100) + '% - ' + nomeVoto
  }
  
  renderPiesAgente = utenteId => {
    return (
      <Query 
        query={statsAgentePieCharts}
        variables={{ agenteId: utenteId }}
        fetchPolicy="cache-and-network"
      >
        {({ loading, error, data }) => {
          if (loading) return <p>Loading...</p>
          if (error) return <p>Error :(</p>

          const sortedStats = type => {
            return _orderBy(data.statsAgentePieCharts[type], ['valore'], ['desc'])
          }

          const values = type => {
            return sortedStats(type).map(stat => stat.valore)
          }

          const labels = type => {
            return sortedStats(type).map(stat => {return this.renderNomeVoto(stat.nome, stat.valore, values(type))})
          }

          const datasets = type => {
            const hoverColors = [`hsla(${azure}, 0.8)`, `hsla(${red}, 0.8)`, `hsla(${orange}, 0.8)`, `hsla(${blue}, 0.8)`, `hsla(${green}, 0.8)`]
            const colors = [`hsla(${azure}, 1)`, `hsla(${red}, 1)`, `hsla(${orange}, 1)`, `hsla(${blue}, 1)`, `hsla(${green}, 1)`]

            return pieChartDataset(labels(type), colors, colors, hoverColors, values(type))
          }

          const pieChartOptions = title => {
            return {
              maintainAspectRatio: false,
              layout: {
                padding: {
                  bottom: 0,
                }
              },
              title: {
                display: true,
                text: title,
                fontSize: 20,
                fontStyle: 'normal',
                padding: 20
              },
              legend: {
                display: true,
                position: 'right',
                labels: {
                  boxWidth: 13,
                  padding: 10
                }
              },
              pieceLabel: {
                render: 'percentage',
                fontColor: '#fff',
                position: 'border',
                textShadow: true
              }
            }
          }

          return (
            <GridContainer
              justify="space-around"
              alignItems="flex-start"
              direction="row"
              style={{ padding: '60px 0 20px' }}
            >
              <ItemGrid xs={12} md={8} lg={6} xl={5}>
                <div className="chart-container" style={{ height: 350, border: '1px solid #ccc', margin: '10px 0', padding: '0 20px 20px' }}>
                  <Pie
                    data={{
                      labels: labels('votiForm'),
                      datasets: [datasets('votiForm')]
                    }} 
                    options={pieChartOptions('Voti da form')} 
                  />
                </div>
              </ItemGrid>
  
              <ItemGrid xs={12} md={8} lg={6} xl={5}>
                <div className="chart-container" style={{ height: 350, border: '1px solid #ccc', margin: '10px 0', padding: '0 20px 20px' }}>
                  <Pie
                    data={{
                      labels: labels('votiAppuntamento'),
                      datasets: [datasets('votiAppuntamento')]
                    }} 
                    options={pieChartOptions('Voti da appuntamento')} 
                  />
                </div>
              </ItemGrid>
            </GridContainer>
          )
        }}
      </Query>
    )
  }

  render() {
    const { utenteId } = this.props
    
    return (
      this.renderPiesAgente(utenteId)
    )
  }
}

export default withStyles(chartsStyle)(Performance)



// WEBPACK FOOTER //
// ./src/views/App/Agenti/Performance.jsx